/**
 * Shared legal / support links, used by the desktop Footer, the mobile drawer
 * and the sign-in screen so they can't drift. These are IN-APP routes: the
 * pages render the brand's PUBLISHED legal text and contact details live from
 * Globus (see pages/LegalPage), inside the app shell when signed in and
 * standalone when not.
 */
export const LEGAL_LINKS = [
  { label: 'Privacy Policy', to: '/privacy-policy' },
  { label: 'Disclaimer', to: '/disclaimer' },
  { label: 'Contact Us', to: '/contact' },
] as const;

export const COPYRIGHT = `© ${new Date().getFullYear()} Alliance Abroad Group`;
